var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,4 C15.8659932,4 19,7.17131633 19,11.0833333 C19,13.4715533 17.7383189,15.812172 15.6581669,18.0340275 C14.9449015,18.7958817 14.1827771,19.4899593 13.4204237,20.1042453 C13.153179,20.3195847 12.9045216,20.5099109 12.6805465,20.6735964 C12.5440568,20.7733458 12.4446018,20.8430476 12.3882901,20.8810356 C12.1531605,21.0396548 11.8468395,21.0396548 11.6117099,20.8810356 C11.5553982,20.8430476 11.4559432,20.7733458 11.3194535,20.6735964 C11.0954784,20.5099109 10.846821,20.3195847 10.5795763,20.1042453 C9.81722289,19.4899593 9.05509853,18.7958817 8.34183312,18.0340275 C6.2616811,15.812172 5,13.4715533 5,11.0833333 C5,7.17131633 8.13400676,4 12,4 Z M12,5.41666667 C8.9072054,5.41666667 6.4,7.95371973 6.4,11.0833333 C6.4,13.0336551 7.5008189,15.0758489 9.35816688,17.0597225 C10.0230265,17.7698735 10.7374646,18.4205225 11.4516737,18.9960151 C11.7012259,19.1970982 11.9324513,19.3740816 12.1391403,19.5251341 L12,19.4218333 L12.02038,19.4070113 C12.1296646,19.3250596 12.2446951,19.2367395 12.3646954,19.1422801 L12.5483263,18.9960151 C13.2625354,18.4205225 13.9769735,17.7698735 14.6418331,17.0597225 C16.4991811,15.0758489 17.6,13.0336551 17.6,11.0833333 C17.6,7.95371973 15.0927946,5.41666667 12,5.41666667 Z M12,8.24999991 C13.5463973,8.24999991 14.8,9.51852645 14.8,11.0833332 C14.8,12.64814 13.5463973,13.9166666 12,13.9166666 C10.4536027,13.9166666 9.2,12.64814 9.2,11.0833332 C9.2,9.51852645 10.4536027,8.24999991 12,8.24999991 Z M12,9.66666657 C11.2268014,9.66666657 10.6,10.3009298 10.6,11.0833332 C10.6,11.8657366 11.2268014,12.4999999 12,12.4999999 C12.7731986,12.4999999 13.4,11.8657366 13.4,11.0833332 C13.4,10.3009298 12.7731986,9.66666657 12,9.66666657 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/location",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/light-grey",
    mask: "url(#mask-2)",
    fill: "#B2B2B2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9088848f92a4d0eae5664d3b84e26336.svg";
export { ForwardRef as ReactComponent };